import React from 'react';
import styled from 'styled-components';
import Calendar from 'rev.sdk.js/Components/Calendar';
import {DT, getWeekday} from 'rev.sdk.js/Components/Calendar/CalendarUtil';
import {Link} from 'gatsby';
import useArea from '../../Hooks/useArea';
import {useOutlet} from 'reconnect.js';
import Theme from '../../Theme';

function DateCell(props) {
  const {
    year,
    month,
    date,
    products,
    classNames: _classNames,
    onClick,
    area,
  } = props;

  const curr = DT({year, month, date});
  const weekday = getWeekday({year, month, date});
  const [dimension] = useOutlet('dimension');

  let availSessions = [];
  let classNames = [];

  for (const product of products) {
    let splited = (product.start_date ?? '').split('-');

    const start = new Date(
      parseInt(splited[0]),
      parseInt(splited[1]) - 1,
      parseInt(splited[2]),
    );
    let end = null;
    if (product.end_date) {
      splited = product.end_date.split('-');
      end = new Date(
        parseInt(splited[0]),
        parseInt(splited[1]) - 1,
        parseInt(splited[2]),
      );
    }
    const now = new Date(year, month, date);

    if (now >= start && (end ? now <= end : now <= start)) {
      availSessions.push(product);
    }
  }

  if (availSessions.length === 0) {
    classNames.push('disabled');
  }

  return (
    <DateCellWrapper
      className={_classNames.concat(classNames).join(' ')}
      onClick={(e) => {
        onClick(e);
      }}>
      <div className="label">
        {dimension.innerWidth > Theme.breakpoint ? (
          `${date}  `
        ) : (
          <>
            {month + 1}/{date}
            <span className="weekday">
              星期{getWeekday({year, month, date})}
            </span>
          </>
        )}
        {/* {date}{' '} */}

        {curr.setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)
          ? '今天'
          : ''}
      </div>
      {availSessions.map((product) => (
        <Link
          className="product"
          to={`/${area}/events/content?id=${product.id}`}>
          {product.name}
        </Link>
      ))}
    </DateCellWrapper>
  );
}

const DateCellWrapper = styled.div`
  // position: relative;

  /* here to custom*/
  &.r-cell {
    align-items: flex-start;
    justify-content: flex-start;
  }
  &.disabled::after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  &.r-cell.r-date:not(.disabled, .past):hover {
    color: inherit;
  }
  &.r-cell.r-date.r-today {
    border-color: inherit;
    box-shadow: 0px 0px 0px 2px var(--thirdColor) inset;
  }

  &.r-today::after {
    content: '';
  }

  &.r-cell.r-date.r-today.r-selected {
    font-wieght: 600;
    background-color: #ffffff;
  }

  &.r-cell.r-date.r-selected {
    background-color: inherit;
    border: 1px solid #fff;
  }

  &.r-cell.r-date:not(.disabled, .past):hover {
    border-color: #fff;
    background-color: #fff;
    cursor: default;
  }

  & > .label {
    padding: 4px;
    font-size: 1rem;
    color: #707070;
  }
  &.r-cell.r-date.r-today > .label {
    color: var(--thirdColor);
    font-weight: bold;
  }

  & > .product {
    width: 100%;
    padding: 4px;
    margin-bottom: 2px;
    background-color: var(--thirdLightColor);
    border: 1px solid var(--thirdThBorderColor);
    color: inherit;
    font-size: 12px;
  }
  & > .product:hover {
    color: #fff;
    background-color: #557ad2;
  }

  @media (max-width: ${Theme.breakpoint}px) {
    & > .product {
      font-size: 1rem;
      padding: 10px;
      border-radius: 5px;
    }
    & > .label {
      & > span {
        font-size: 80%;
        display: inline-block;
        margin-left: 5px;
      }
    }
  }
`;

function ProductCalendar(props) {
  const {
    year,
    month,
    size,
    products,
    selectedDt,
    setSelectedDt,
    onClickPrev,
    onClickNext,
    renderMonthHeader,
  } = props;
  const {area} = useArea();

  return (
    <Wrapper size={size}>
      <div className="calendar">
        <Calendar
          year={year}
          month={month}
          onSelect={({year, month, date, dt}) => {
            setSelectedDt(
              selectedDt
                ? selectedDt.getTime() === dt.getTime()
                  ? null
                  : dt
                : dt,
            );
          }}
          renderDate={(props) => {
            return (
              <DateCell
                key={props.date}
                {...props}
                products={products}
                area={area}
              />
            );
          }}
          onClickPrev={onClickPrev}
          onClickNext={onClickNext}
          renderMonthHeader={renderMonthHeader}
        />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 20px;
  width: ${(props) => props.size}px;

  & > .calendar {
    & > div {
      background-color: white;
    }

    & .r-weekdays {
      flex-grow: 0;
      flex-basis: 40px;
      border-bottom: solid 2px var(--thirdThBorderColor);

      & > .r-cell:first-child,
      & > .r-cell:last-child {
        color: #c00;
      }
    }

    & .r-inner > .r-row.r-head {
      & > .r-cell.r-title {
        font-weight: 500;
      }

      & > .r-cell.r-next:hover,
      .r-cell.r-prev:hover {
        background-color: var(--primaryColor);
      }
    }

    & .r-dates > .r-row {
      border-bottom: solid 1px var(--thirdThBorderColor);
    }
    & .r-dates .r-cell:not(:last-child) {
      border-right: solid 1px var(--thirdThBorderColor);
      padding: 1px;
    }
  }

  @media (max-width: ${Theme.breakpoint}px) {
    & .calendar > div::after {
      display: none !important;
    }

    & .r-inner {
      position: relative;
    }

    & .r-dates {
      margin: 10px 0;
    }

    & .r-row {
      flex-direction: column;
      border: none !important;
    }

    & .r-weekdays {
      display: none;
    }

    & .r-row .r-cell {
      border: none !important;
      padding: 10px 0 !important;
      border-top: solid 1px var(--thirdThBorderColor) !important;
      padding: 5px !important;
    }
    & .r-row .r-cell:not(.r-date) {
      display: none;
    }
  }
`;

export default ProductCalendar;
